// src/components/CustomSettingsToolbarItem.tsx
import React from 'react';
import SettingsDropdown from './SettingsDropdown';
import { SavedSetting } from '../components/library/page-setting/SettingsPopup';


interface CustomSettingsToolbarItemProps {
  gridRef: any;
  settingPage: string;
  settingObject: string;
  t: (key: string) => string;
  savedSettings: SavedSetting[];
  setSavedSettings: React.Dispatch<React.SetStateAction<SavedSetting[]>>;
  settingsDropdownOpened: boolean;
  setSettingsDropdownOpened: React.Dispatch<React.SetStateAction<boolean>>;
  handleSettingsItemClick: (e: any) => void;
}

const CustomSettingsToolbarItem: React.FC<CustomSettingsToolbarItemProps> = ({
  gridRef,
  settingPage,
  settingObject,
  t,
  savedSettings,
  setSavedSettings,
  settingsDropdownOpened,
  setSettingsDropdownOpened,
  handleSettingsItemClick,
}) => {
  
  return (
    <div>
      <SettingsDropdown
        savedSettings={savedSettings}
        setSavedSettings={setSavedSettings}
        settingsDropdownOpened={settingsDropdownOpened}
        setSettingsDropdownOpened={setSettingsDropdownOpened}
        handleSettingsItemClick={handleSettingsItemClick}
        settingPage={settingPage}
        settingObject={settingObject}
        t={t}
      />
    </div>
  );
};

export default CustomSettingsToolbarItem;
